import { Discipline, DisciplineCodes } from 'core/typings';

import {
  CookieConfig,
  SharePlatformDetail,
} from './typings/configs';

export const COOKIE_CONFIG: CookieConfig = {
  cookiePolicy: 'c_policy',
  cookiePolicyExpirationDays: 60,
  xsrfRequestToken: 'XSRF-REQUEST-TOKEN',
};

export const CSS_CLASSES = {
  isActive: 'is-open',
  isOpen: 'is-open',
  isShowing: 'is-showing',
  navIsShowing: 'nav-is-showing',
  overlayIsShowing: 'overlay-is-showing',
};

export const SHARE_PLATFORM_DETAILS: SharePlatformDetail[] = [
  {
    id: 'facebook',
    shareUrl: 'https://www.facebook.com/sharer/sharer.php?u=',
  },
  {
    id: 'twitter',
    shareUrl: 'https://twitter.com/intent/tweet?url=',
  },
  {
    id: 'whatsapp',
    shareUrl: 'whatsapp://send?text=',
  },
  {
    id: 'copylink',
    shareUrl: null,
  },
];

export const DISCIPLINE: Record<Discipline, DisciplineCodes> = {
  'bmx-freestyle': 'bfr',
  'bmx-racing': 'bmx',
  'cycling-esport': 'ces',
  'cyclo-cross': 'cro',
  gravel: 'gra',
  indoor: 'ind',
  'mountain-bike': 'mtb',
  para: 'par',
  road: 'roa',
  track: 'pis',
  trials: 'tri',
  other: 'cpt',
};
